import { IButtonProps, ICommandBarProps, ICommandBarStyles, SelectionMode } from '@fluentui/react';
import { UATConstants } from 'src/Common/Models/UATConstants';
import { ChildActions } from '../interfaces/HubOverviewModels';
import { createAction } from '@reduxjs/toolkit';
import { IWorkItem } from 'src/manageAction/interfaces/WorkItem';

export const commandBarProps: ICommandBarProps = {
  styles: { root: { paddingInline: 8 } },
  items: [],
  farItems: [],
  overflowButtonProps: { ariaLabel: 'Data grid overflow actions' },
};
export interface ChildActions {
  id: number;
  childActions: IWorkItem[];
}
export const commandBarStyles: Partial<ICommandBarStyles> = {
  root: {
    paddingLeft: '0px',
  },
};

export const headerStyles = {
  root: {
    border: 'none',
  },
};

export const overflowProps: IButtonProps = {
  ariaLabel: 'More commands',
  style: { color: '#0078D4' },
};

export const selectionMode = (option: 'single' | 'multi' | undefined) => {
  // NOTE: Change option to view different selection modes
  switch (option) {
    case 'single':
      return SelectionMode.single;
    case 'multi':
      return SelectionMode.multiple;
    default:
      return SelectionMode.none;
  }
};

export const clearGlobalSearch = () => {
  const clearButton = document.querySelector('[aria-label="clear"]');
  if (clearButton) {
    clearButton.click();
  }
};

export const getSortableColumns = (uatDataDictionary: any[]): string[] => {
  return (
    uatDataDictionary
      ?.filter((column: any) => column.sortable === true)
      ?.map((column: any) => column.internalName) || []
  );
};

export const isValidRelatedItem = (relation: any) => {
  return !relation.isdeleted &&
  (
      relation.rel === UATConstants.PlaceholdersAndTitles.ChildRelation ||
      relation.rel === UATConstants.PlaceholdersAndTitles.RelatedRelation ||
      relation.rel === UATConstants.PlaceholdersAndTitles.RelatedHyperLinks ||
      relation.rel === UATConstants.PlaceholdersAndTitles.ChildRelationReverse ||
      relation.rel === UATConstants.PlaceholdersAndTitles.RelatedRelationRemote
  );
}

export const processRelations = (item: any) => {
  let relatedLinks: number[] = [];
  const relatedRelation: number[] = [];
  const relatedHyperlinks: number[] = [];

  item?.raidCorrelation.forEach((element: any) => {
    if (
      isValidRelatedItem(element) && 
      element?.url !== undefined &&
      element?.url !== null
    ) {
      const raidid = element.id;
      if (raidid !== null) {
        if (element.rel === UATConstants.PlaceholdersAndTitles.RelatedRelation) {
          relatedRelation.push(Number(raidid)); // Use `Number` to ensure consistent type
        } else if (element.rel === UATConstants.PlaceholdersAndTitles.RelatedHyperLinks) {
          relatedHyperlinks.push(Number(raidid));
        } else {
          relatedLinks.push(Number(raidid));
        }
      }
    }
  });

  // Combine arrays
  relatedLinks = [...relatedRelation, ...relatedLinks];
  return relatedLinks;
};

export const DASHBOARD_SUMMARY_ACTIONS = {
  SET_CHILD_ACTION_ITEMS: 'setChildActionItems',
  REMOVE_CHILD_ACTION_ITEMS: 'removeChildActionItems',
};

export const setChildActionItems = createAction(
  DASHBOARD_SUMMARY_ACTIONS.SET_CHILD_ACTION_ITEMS,
  function prepare(childActionItems: ChildActions) {
    //It is important to mark the child actions so that they can be identified in the grid.
    childActionItems.childActions.map((item:any) => {
      item['isChildAction'] = true;
      return item;
    });
    return {
      payload: childActionItems,
    };
  }
);

export const removeChildActionItems = createAction(
  DASHBOARD_SUMMARY_ACTIONS.REMOVE_CHILD_ACTION_ITEMS,
  function prepare(childActionItems: ChildActions) {
    return {
      payload: childActionItems,
    };
  }
);

export const getInternalName = (path: string) => {
  const segments = path.split('/'); // Split the string into parts
  if (segments.length > 1 && segments[segments.length - 1] === 'uniquename') {
    return segments[segments.length - 2]; // Return the second-to-last segment
  }
  return segments.pop() || path; // Otherwise, return the last segment
};

export const extractMilestoneId = (data, path) => {
  const keys = path.split('/');
  let current = data;
  for (const key of keys) {
    if (Array.isArray(current)) {
      // If current is an array, iterate and check each element
      current = current.map((item) => item[key]).filter(Boolean);
      current = current.length === 1 ? current[0] : current;
    } else if (current[key]) {
      current = current[key]; // Navigate the object using the key
    } else {
      return null;
    }
  }
  return current;
};

export const findMatchingObject = (selectedItemArr, AllItemsArr) => {
  const raidIds = selectedItemArr.map((item) => item.raidid); // Extract raidids from the first array
  // Filter the second array to find matching objects
  const matchedObjects = AllItemsArr.filter((item) => raidIds.includes(item.raidid));
  return matchedObjects; // Return all matched objects
};